import { render, staticRenderFns } from "./StudentTestimonialChangeOfSchool.vue?vue&type=template&id=f3dd2ba2"
import script from "./StudentTestimonialChangeOfSchool.vue?vue&type=script&lang=js"
export * from "./StudentTestimonialChangeOfSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports